import {
	Container,
	ContainerGutter,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { SilverLabel } from './silver-label';

const MainContainer = styled(Container)`
	overflow: visible;
	padding: 0px;
	align-content: center;

	/* Mobile */
	@media (max-width: 1599px) {
		padding-top: 40px;
	}

	/* Desktop */
	@media (min-width: 1600px) {
		padding-top: 24px;
	}
`;

const StyledC3Wrapper = styled.div`
	border: 2px solid #00b0f0;
	border-radius: 16px;
	position: relative;
	align-content: center;

	/* Mobile */
	@media (max-width: 1599px) {
		height: 280px;
	}

	/* Tablet */
	@media (min-width: 1600px) {
		height: 270px;
	}
`;

const StyledTextWrapper = styled(Container)`
	border-top: 2px solid #00b0f0;
	border-bottom: 2px solid #00b0f0;
	padding-top: var(--size-dynamic0050);
	padding-bottom: var(--size-dynamic0050);
	padding-left: 4px;
	padding-right: 4px;
	width: 292px;

	/* Aseguramos que el wrapper se centre horizontalmente cuando el padre hace wrap='always' */
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 559px) {
		max-width: 227px;
	}
`;

const TextLarge = styled(Text)`
	font-size: 87px;
	line-height: 100%;

	/* Mobile */
	@media (max-width: 559px) {
		font-size: 60px;
	}
`;

const SymbolText = styled(Text)`
	font-size: 44px;
	line-height: 120%;
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;

	/* Mobile */
	@media (max-width: 559px) {
		margin-top: 0px;
	}
`;

export const PopupRenovadoresBonusCardC3 = () => {
	const badge = '2'; // badge siempre es "2" respecto al popup/pdf

	return (
		<MainContainer stretchContent data-testid="c3-container">
			<StyledC3Wrapper>
				<SilverLabel />
				<Container
					gutter={ContainerGutter.dynamic0100}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="c3-inner-container"
					wrap="always"
				>
					<Container wrap="never" horizontalAlign="center">
						<Container wrap="never" verticalAlign="flex-end">
							<TextLarge color={TokenTextColor.inverted}>+1.000</TextLarge>
							<SymbolText color={TokenTextColor.inverted}>{'€'}</SymbolText>
						</Container>
						<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
					</Container>

					<StyledTextWrapper stretchContent verticalAlign="center" horizontalAlign="center">
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.inverted}
							textAlign={TextAlignment.center}
						>
							{'La Excusa Oficial Volkswagen para renovar tu coche este año'}
						</Text>
					</StyledTextWrapper>
				</Container>
			</StyledC3Wrapper>
		</MainContainer>
	);
};
